import Question from './Question';

export default null;
export { Question };



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/components/index.js